import { render, staticRenderFns } from "./AddAccountant.vue?vue&type=template&id=2589189f"
import script from "./AddAccountant.vue?vue&type=script&lang=js"
export * from "./AddAccountant.vue?vue&type=script&lang=js"
import style0 from "./AddAccountant.vue?vue&type=style&index=0&id=2589189f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports